import React from 'react';
import { useSelector } from 'react-redux';
import { useAppContext } from 'Context/ReactAppContext';
import { PLE_GREAT_MEMBERS_PAGE_ID } from 'Routes/constants';
import { userInfoSelector } from 'Store/user-info/userInfo.selectors';
import { STATIC_PAGE_TYPES } from 'Tracking/constants';
import { useGQL } from 'Utils/graphql-client/use-gql/useGQL';
import { isTokenValid } from 'Utils/ple-utils/handleInvalidToken';
import {
  CUSTOMER_ACCOUNT_GET_CMS_DATA_GREATMEMBERS,
  CUSTOMER_ACCOUNT_GET_LOYALTY_DETAILS,
  CUSTOMER_ACCOUNT_GET_LOYALTY_PROGRAM,
} from 'Utils/request/requestDictionary';
import { SpinnerHandler } from 'Components/frameworks/spinner-handler/SpinnerHandler';
import { getLoyaltyProgramQuery, getLoyaltyQuery } from './GreatMembersView.queries';
import { GreatMembersView } from './GreatMembersView';
export const GreatMemberViewContainer = () => {
  const appContext = useAppContext();
  const userInfo: UserInfo | null | undefined = useSelector(userInfoSelector);
  const { isLoading, data } = useGQL(
    {
      query: '',
      queryOptions: {
        requestName: CUSTOMER_ACCOUNT_GET_CMS_DATA_GREATMEMBERS,
        queryId: CUSTOMER_ACCOUNT_GET_CMS_DATA_GREATMEMBERS,
      },
      cache: true,
      map: ({ config }) => ({
        animation: config.customerAccount?.greatMember?.animation?.items || [],
      }),
    },
    {
      query: getLoyaltyProgramQuery(),
      queryOptions: {
        requestName: CUSTOMER_ACCOUNT_GET_LOYALTY_PROGRAM,
      },
      cache: true,
    },
    {
      query: getLoyaltyQuery(),
      queryOptions: {
        requestName: CUSTOMER_ACCOUNT_GET_LOYALTY_DETAILS,
      },
      cache: false,
      catch: () => {},
      ignore: !appContext.isUserLogged || !isTokenValid(userInfo),
    },
  );
  return (
    <SpinnerHandler isLoading={isLoading}>
      {data && (
        <GreatMembersView
          animation={data.animation}
          loyaltyProgram={data.loyaltyProgram}
          loyaltyProgramSimulation={data.loyaltyProgramSimulation}
          profile={data.profile}
        />
      )}
    </SpinnerHandler>
  );
};
GreatMemberViewContainer.pageId = PLE_GREAT_MEMBERS_PAGE_ID;
GreatMemberViewContainer.pageType = STATIC_PAGE_TYPES.PLE;
